import React, { useEffect, useState } from "react";
import Form from "../../components/formWrapper/FormWrapper";
import * as Yup from "yup";
import {
  validateEmail,
  validatePassword,
} from "../../../shared/utils/validation";
import UserAdminForm from "./userAdminForm";

const UserAdmin = (props) => {
  const { formStatus, userSelected, changeStatus, handleSubmit, t } = props;
  const [validationSchema, setValidationSchema] = useState({});

  useEffect(() => {
    if (formStatus === "edit") {
      const validation = Yup.object().shape({
        name: Yup.string()
          .required(t("common:validations.required"))
          .matches(
            /^[[a-zA-ZÀ-ÿ\u00f1\u00d1]*(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s-]+$/,
            "Only alphabets are allowed for this field "
          ),
        lastName: Yup.string()
          .required(t("common:validations.required"))
          .matches(
            /^[[a-zA-ZÀ-ÿ\u00f1\u00d1]*(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s-]+$/,
            "Only alphabets are allowed for this field "
          ),
        email: validateEmail(t("common:validations.email")).required(
          t("common:validations.required")
        ),
        role: Yup.string().required(t("common:validations.required")),
      });

      setValidationSchema(validation);
    } else {
      const validation = Yup.object().shape({
        name: Yup.string()
          .required(t("common:validations.required"))
          .matches(
            /^[[a-zA-ZÀ-ÿ\u00f1\u00d1]*(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s-]+$/,
            "Only alphabets are allowed for this field "
          ),
        lastName: Yup.string()
          .required(t("common:validations.required"))
          .matches(
            /^[[a-zA-ZÀ-ÿ\u00f1\u00d1]*(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s-]+$/,
            "Only alphabets are allowed for this field "
          ),
        password: validatePassword(t("common:validations.password"))
          .required(t("common:validations.required"))
          .min(8, "Password must be at least 8 characters"),
        email: validateEmail(t("common:validations.email")).required(
          t("common:validations.required")
        ),
        role: Yup.string().required(t("common:validations.required")),
      });

      setValidationSchema(validation);
    }
  }, [formStatus]);

  const initUser = {
    name: userSelected.name || "",
    lastName: userSelected.last_name || "",
    email: userSelected.email || "",
    role: userSelected.role || "",
    password: "",
    accountType: userSelected.accountType || "Freemium",
  };

  const handleCancel = () => {
    props.handleCancel && props.handleCancel();
  };

  const handleDelete = () => {
    props.handleDelete && props.handleDelete();
  };

  const renderComponent = (props) => {
    return (
      <UserAdminForm
        {...props}
        formStatus={formStatus}
        changeStatus={changeStatus}
        handleCancel={handleCancel}
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        t={t}
      />
    );
  };

  return (
    <Form
      initialValues={initUser}
      component={renderComponent}
      enableReinitialize={true}
      validationSchema={validationSchema}
    />
  );
};

export default UserAdmin;
